import Content from '../../content.js';

namespace('IO.Views.TwoFactorAuths', function (exports) {
  'use strict';

  var defaults = {
      pollAuthTimeout: 3000,
    },
    New = Content.extend({
      dom: {
        CHECKED_RADIO: 'input[name=factor]:checked',
        FORM: '.duo-form',
        PASSCODE: '.auth-passcode',
        PASSCODE_CONTAINER: '.two-factor-passcode',
        PASSCODE_FIELD: '.passcode-field',
        PASSCODE_RADIO: '.duo-form .auth-passcode > input[type=radio]',
        RADIOS: '.duo-form input[type=radio]',
        SUBMIT_FORM_BUTTON: '.submit',
        SPINNER: '.spinner',
      },

      events: function () {
        var events = {};

        events['change ' + this.dom.RADIOS] = '_radioHandlers';
        events['click ' + this.dom.PASSCODE_RADIO] = '_expandPasscodeInput';
        events['submit ' + this.dom.FORM] = '_sendAuth';
        return events;
      },

      initialize: function (options) {
        this.opts = _.defaults(defaults, options);
        this.render();
      },

      render: function () {
        //      this.spinner = new Spinner()
        this._checkPreviousPasscode();
        $('.sidebar').remove();
        $('.link-list').remove();
        $('.user-menu').remove();
        $('.content-wrapper').removeClass('ten').addClass('twelve');
        $('body').addClass('not-logged');
      },

      _checkPreviousPasscode: function () {
        var device = sessionStorage.getItem('device');

        if (device) {
          this._selectPasscode(true);
          sessionStorage.removeItem('device');
        }
      },

      _radioHandlers: function (e) {
        this._setSubmitButtonText(e);
        this._updateInputState(e);
      },

      _setSubmitButtonText: function (e) {
        var selectedRadio = e.currentTarget.value,
          $submitButton = $(e.currentTarget)
            .closest(this.dom.FORM)
            .find(this.dom.SUBMIT_FORM_BUTTON),
          $submitButtonText = $submitButton.find('.text');

        if (selectedRadio === 'passcode') {
          $submitButtonText.text('Submit');
          this._submitingButtonText = 'Submitting...';
          this._submitButtonText = 'Submit';
        } else {
          $submitButtonText.text('Send');
          this._submitingButtonText = 'Sending...';
          this._submitButtonText = 'Send';
        }
        this.factor = selectedRadio;
      },

      _updateInputState: function (e) {
        var selectedRadioValue = e.currentTarget.value,
          parentForm = $(e.target).closest(this.dom.FORM);

        if (selectedRadioValue !== 'passcode') {
          parentForm.find(this.dom.PASSCODE_CONTAINER).hide();
        }
      },

      _expandPasscodeInput: function (e) {
        var $parentLabel = $(e.target).parent();

        this.$(this.dom.PASSCODE_CONTAINER).hide();
        $parentLabel.find(this.dom.PASSCODE_CONTAINER).show();
        $parentLabel.find(this.dom.PASSCODE_FIELD).trigger('focus');
      },

      // AUTH REQUEST
      _sendAuth: function (e) {
        var authParams = {},
          $selectedRadio = this.$(this.dom.CHECKED_RADIO);

        authParams.factor = $selectedRadio.val();
        authParams.authenticity_token = $('meta[name=csrf-token]').attr(
          'content',
        ); // eslint-disable-line camelcase

        if (!authParams.factor) {
          return false;
        }

        e.preventDefault();
        e.stopPropagation();

        switch (authParams.factor) {
          case 'passcode':
            authParams.passcode = $selectedRadio
              .closest(this.dom.PASSCODE)
              .find(this.dom.PASSCODE_FIELD)
              .val();
            break;
          default:
            authParams.device = $selectedRadio.data('device');
            break;
        }

        this._disableForm();
        this._sendAuthRequest(authParams);
      },

      _disableForm: function () {
        var $submitButtonText = this.$(this.dom.SUBMIT_FORM_BUTTON).find(
            '.text',
          ),
          els = [this.dom.RADIOS, this.dom.SUBMIT_FORM_BUTTON].join(', ');

        this.$(els).attr('disabled', 'disabled');
        $submitButtonText.text(this._submitingButtonText);
      },

      _sendAuthRequest: function (authParams) {
        var processAuthRequest = $.proxy(this._processAuthRequest, this),
          processAuthRequestError = $.proxy(
            this._processAuthRequestError,
            this,
          );

        console.log(
          'Sending auth request (' +
            authParams.factor + // eslint-disable-line no-console
            ') for device ' +
            authParams.device,
        );

        $.post('/two_factor_auth/auth', authParams)
          .done(processAuthRequest)
          .fail(processAuthRequestError);
      },

      _processAuthRequest: function (response) {
        switch (response.stat) {
          case 'OK':
            this.txid = response.response.txid;
            this._pollAuthStatus();
            if (this.factor === 'push') {
              this._pushSentMessage();
              this._showSpinner();
            }
            break;
          case 'FAIL':
            console.log(
              'There was an error authenticating. Reason:' + response.message,
            ); // eslint-disable-line no-console
            if (response.message_detail === 'timeout') {
              this._processError(
                'Authentication failed. Try again in a few moments.',
              );
            } else {
              this._processError(
                'Authentication failed. Please contact your administrator for help.',
              );
            }
            break;
          default:
            break;
        }
      },

      _processAuthRequestError: function () {
        this._processError('There was an error performing the auth request.');
      },

      _processError: function (message) {
        this._errorMessage(message);
        this._clearForm();
        this._hideSpinner();
      },

      // AUTH STATUS
      _pollAuthStatus: function () {
        var authStatusParams = { txid: this.txid },
          processAuthStatus = $.proxy(this._processAuthStatus, this),
          processError = $.proxy(this._processError, this);

        $.getJSON('/two_factor_auth/auth_status', authStatusParams)
          .done(processAuthStatus)
          .fail(processError);
      },

      _processAuthStatus: function (response) {
        var pollAuthStatus = $.proxy(this._pollAuthStatus, this),
          resp;

        switch (response.stat) {
          case 'OK':
            resp = response.response;

            switch (resp.result) {
              case 'allow':
                this._authenticatedMessage(resp.status_msg);
                setTimeout(function () {
                  window.location.href = '/';
                }, 1000);
                break;
              case 'deny':
                if (resp.status === 'sent') {
                  this._smsSentMessage(resp.status_msg);
                  this._clearForm();
                  this._selectPasscode();
                } else {
                  this._processError(
                    'Authentication failed. ' + resp.status_msg,
                  );
                }
                break;
              case 'waiting':
                console.log('Still waiting...'); // eslint-disable-line no-console
                this.currentPollTimeout = setTimeout(
                  pollAuthStatus,
                  this.opts.pollAuthTimeout,
                );
                break;
              default:
                break;
            }
            break;

          case 'FAIL':
            console.log(
              'There was an error authenticating. Reason: ' + response.message,
            ); // eslint-disable-line no-console

            if (response.message_detail === 'timeout') {
              this.currentPollTimeout = setTimeout(
                pollAuthStatus,
                this.opts.pollAuthTimeout,
              );
            } else {
              this._processError();
            }
            break;
          default:
            break;
        }
      },

      // ALERTS

      _alert: function (message, type) {
        var alert = new Alert({
          message: message,
          type: type,
        });

        alert.prependTo(this.$('form')).show();
      },

      _smsSentMessage: function (message) {
        this._alert(message, 'notice');
        console.log('SMS was sent, show notice'); // eslint-disable-line no-console
      },

      _authenticatedMessage: function (message) {
        this._alert(message, 'success');
        console.log('Successfully authenticated.'); // eslint-disable-line no-console
      },

      _pushSentMessage: function () {
        this._alert('Waiting for authentication from your device...', 'notice');
        console.log('Push sent. txid=' + this.txid); // eslint-disable-line no-console
      },

      _errorMessage: function (message) {
        if (message === null || typeof message !== 'string') {
          message =
            'Authentication failed. Please contact your administrator for help.';
        }

        this._alert(message, 'alert');
        console.log('Authentication failed.', message); // eslint-disable-line no-console
      },

      // MISC
      _selectPasscode: function (refreshed) {
        var $selectedRadio = this.$('input[name=factor]:checked'),
          device =
            $selectedRadio.data('device') || sessionStorage.getItem('device'),
          $passcodeRadio = this.$(
            '.auth-passcode[data-device=' + device + '] input[value=passcode]',
          );

        if ($passcodeRadio.length) {
          $passcodeRadio.trigger('click');

          if (refreshed) {
            this._expandPasscodeInput({ target: $passcodeRadio[0] });
          }
        } else if (device && !refreshed) {
          sessionStorage.setItem('device', device);
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }
      },

      _clearForm: function () {
        var $submitButtonText = this.$(this.dom.SUBMIT_FORM_BUTTON).find(
            '.text',
          ),
          els = [this.dom.RADIOS, this.dom.SUBMIT_FORM_BUTTON].join(', ');

        this.$(els).prop('disabled', false);
        $submitButtonText.text(this._submitButtonText);
      },

      _hideSpinner: function () {
        var $spinner = this.$(this.dom.SPINNER);

        $spinner.removeClass('visible');
        //      this.spinner.stop()
      },

      _showSpinner: function () {
        var $spinner = this.$(this.dom.SPINNER);

        $spinner.addClass('visible');
        //      this.spinner.spin($spinner[0])
      },
    });

  exports.New = New;
});
